import React from 'react';
import Header from '../Header';
import ActionButton from './ActionButton';
import LittleAskCard from '../LittleAskCard';
import InfoItem from './InfoItem';
import { latLngDecimalToStandard } from '../../helpers/poi';
import localStorageItem from '../../utils/localStorageItem';
import preLoadImg from '../../utils/preLoadImg';
import {push} from '../../native/navigator';
import './index.css';

const LSI = localStorageItem('POI_DETAIL');
const img = 'http://imgcdn1.zuzuche.com/m_tantu_image/20171114/769dc791499b0cdf63ed116561c4805d.jpg!/fw/750/format/webp';
   
export default class CustomPoi extends React.Component{
  render(){
    let { type,backStep, addActionBtnText, stayTime, name, handleLeftButtonClick, center, className } = this.props;
    let { poi_info } = this.props;
    let { allowUpdate } = this.props;
    let { onAdd, onRemove} = this.props;
    let formatelatlng = latLngDecimalToStandard(center.lat, 'lat') + ', ' + latLngDecimalToStandard(center.lng, 'lng');
    return(
      <div id="custom-poi" className={className ? className : ''}>
        <Header 
          title={`自定义${type === 'hotel' ? '酒店' : '地点'}`} 
          backStep={backStep}
          handleLeftButtonClick={handleLeftButtonClick}/>
        <section className="custom-poi-header">
          <h1>{poi_info.info.cn_name || name}</h1>
          <ActionButton onAdd={onAdd} onRemove={onRemove} addActionBtnText={addActionBtnText}/>
        </section>
        <main className="custom-poi-body">
          <div className="custom-poi-image" style={{backgroundImage:`url(${poi_info.info.pic.full || img})`}}>
          </div>
          <InfoItem 
            title="地址"
            content={formatelatlng} 
            allowUpdate={allowUpdate}
            onClick={this.setAddress}/>
          <LittleAskCard poi={poi_info} maxZoom={18} handleClickAskCard={this.handleClickAskCard}/>
          {
            type === 'hotel' ? null : 
              <InfoItem 
                title="时长"
                content={stayTime || '设置游玩时长能规划更合理'} 
                allowUpdate={allowUpdate}
                onClick={this.setStayTime}/>
          }
        </main>
      </div>
    );
  }

  /**
   * 点击问路卡
   */
  handleClickAskCard =()=>{
    let { poi_info } = this.props;
    LSI.setItem('detail', poi_info.info);
    preLoadImg(`${poi_info.info.pic.base}!/fw/750/gaussblur/30x5`);
    push('/m/v2/?m=render2&page=ask-road-card');
  }

  /**
   * 点击编辑地址icon
   */
  setAddress = ()=>{
    if(!this.props.allowUpdate) return;

    this.props.setAddress();
  }

  /**
   * 点击编辑游玩时长icon
   */
  setStayTime = ()=>{
    if(!this.props.allowUpdate) return;

    this.props.setStayTime();
  }
}




// WEBPACK FOOTER //
// ./src/components/CustomPoi/index.js